<template>
  <div>
    <div>
      <span v-if="ocrTab === OCR_TAB_IDENTIFY.code" style="margin: 7px;width: 80px">{{ $t('CargoMsg.Cargo_IdentificationType') }}</span>
      <el-select v-if="ocrTab === OCR_TAB_IDENTIFY.code" v-model="searchConditions.identificationType" no="1" style="width:150px;" @input="(val)=>handleSearch('select',val)">
        <el-option
          v-for="(item,index) in typeList"
          :key="index"
          :label="$getLangColumn(item)"
          :value="item.code"
        />
      </el-select>
      <search-item
        v-if="ocrTab !== OCR_TAB_IDENTIFY.code"
        :config-module="configModule"
        :show-simple="false"
        :expand-adv="true"
        @advSearchItemCallBack="toQuery"
      >
        <template slot="operations">
          <el-dropdown
            v-if="ocrTab === OCR_TAB_PENDING.code"
            no="batchHandle"
            style="margin:0 5px;font-size: 12px"
            @command="batchHandle"
          >
            <el-button type="primary">
              {{ $t('SeaExport.BatchProcessing') }}
              <i class="el-icon-arrow-down el-icon--right" />
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="1">{{
                $t('CargoMsg.Cargo_BatchDelete')
              }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button v-if="ocrTab === OCR_TAB_PENDING.code && $checkPermission(['button_ocrRecognition_supplementaryInformation'])" type="primary" style="width: 120px" @click="()=>$emit('supplementaryInformation')">{{ $t('CargoMsg.Cargo_SupplementaryInformation') }}</el-button>
        </template>

        <!--        <el-form>-->
        <!--          <el-row style="margin-bottom: 5px;" :gutter="10">-->
        <!--            &lt;!&ndash;识别类型&ndash;&gt;-->
        <!--            <el-form-item-->
        <!--              :label="$t('CargoMsg.Cargo_IdentificationType')"-->
        <!--            >-->
        <!--              <el-select v-model="searchConditions.identificationType" no="1" style="width:150px;">-->
        <!--                <el-option-->
        <!--                  v-for="(item,index) in typeList()"-->
        <!--                  :key="index"-->
        <!--                  :label="$getLangColumn(item)"-->
        <!--                  :value="item.code"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;文件名&ndash;&gt;-->
        <!--            <el-form-item-->
        <!--              :label="$t('Messae.FileName')"-->
        <!--            >-->
        <!--              <el-input v-model="searchConditions.fileName" />-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;业务进度&ndash;&gt;-->
        <!--            <el-form-item-->
        <!--              :label="$t('CargoMsg.Cargo_JobProcess')"-->
        <!--            >-->
        <!--              <el-select v-model="searchConditions.jobProcess" no="1" style="width:150px;">-->
        <!--                <el-option-->
        <!--                  v-for="(item,index) in JOB_PROCESS"-->
        <!--                  :key="index"-->
        <!--                  :label="$getLangColumn(item)"-->
        <!--                  :value="item.code"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;来源&ndash;&gt;-->
        <!--            <el-form-item-->
        <!--              :label="$t('CargoMsg.Cargo_CreateSource')"-->
        <!--            >-->
        <!--              <el-select v-model="searchConditions.source" no="1" style="width:150px;">-->
        <!--                <el-option-->
        <!--                  v-for="(item,index) in INTELLIGENT_DOCUMENT_SOURCE_LIST"-->
        <!--                  :key="index"-->
        <!--                  :label="$getLangColumn(item)"-->
        <!--                  :value="item.code"-->
        <!--                />-->
        <!--              </el-select>-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;业务编号&ndash;&gt;-->
        <!--            <el-form-item-->
        <!--              :label="$t('CargoMsg.Cargo_BusinessNo')"-->
        <!--            >-->
        <!--              <el-input v-model="searchConditions.jobNo" />-->
        <!--            </el-form-item>-->
        <!--            &lt;!&ndash;上传时间&ndash;&gt;-->
        <!--            &lt;!&ndash;          zrd todo&ndash;&gt;-->
        <!--          </el-row>-->
        <!--        </el-form>-->
      </search-item>
      <!--      <el-button v-if="showRefresh" no="3" style="height: 28px;" type="primary" @click="()=>handleSearch('refresh')">{{ $t('FileHistory.Refresh') }}</el-button>-->
    </div>
    <!--    <div v-if="showFormItem" class="search-bar-form-item">-->
    <!--      <el-radio-group v-model="dateRange" no="4" @change="(val)=>handleSearch('range',val)">-->
    <!--        <el-radio :label="7">{{ $t('SeaExport.NearlyAWeek') }}</el-radio>-->
    <!--        <el-radio :label="30">{{ $t('SeaExport.NearlyAMonth') }}</el-radio>-->
    <!--        <el-radio :label="90">{{ $t('SeaExport.NearlyThreeMonths') }}</el-radio>-->
    <!--      </el-radio-group>-->
    <!--    </div>-->
  </div>
</template>

<script>
import {
  IDENTIFICATION_TYPE_1,
  IDENTIFICATION_TYPE_2, IDENTIFICATION_TYPE_3,
  INTELLIGENT_DOCUMENT_SOURCE_LIST, JOB_PROCESS, OCR_TAB_IDENTIFY, OCR_TAB_PENDING,
  SENDING,
  SENDING_2
} from '@/class/cargo/model/parameters/SystemConstants'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import OcrUtils from '@/utils/OcrUtils'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'

export default {
  name: 'SearchBar',
  components: { searchItem },
  props: {
    showRefresh: {// 是否显示刷新按钮
      type: Boolean,
      default: () => true
    },
    // showType: { // 识别类型下拉框数据
    //   type: Number,
    //   default: () => 0
    // },
    showInputVal: { // 是否显示搜索
      type: Boolean,
      default: () => true
    },
    showFormItem: { // 是否显示日期范围
      type: Boolean,
      default: () => false
    },
    ocrTab: {
      type: Number,
      default: () => 0
    },
    configModule: {
      type: String,
      default: ''
    },
    filter: {
      type: Object,
      default: () => {}
    },
    source: { // 来源【0-海出 1-远程订舱-海运】
      type: Number,
      default: () => 0
    },
    typeList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      IDENTIFICATION_TYPE_1,
      IDENTIFICATION_TYPE_2,
      SENDING,
      SENDING_2,
      dateRange: 7,
      inputVal: '',
      // recognitionType: -1,
      searchConditions: {
        iType: 0, // 识别类型
        identificationType: 0
      },
      INTELLIGENT_DOCUMENT_SOURCE_LIST, OCR_TAB_IDENTIFY, OCR_TAB_PENDING
    }
  },
  // 暂时不做限制
  // watch: {
  //   source: {
  //     immediate: true,
  //     handler(newVal) {
  //       console.log('this.source:', this.source)
  //       const { typeList } = OcrUtils.getIdentificationTypes(this.source)
  //       const defaultSearchFields = []
  //       // 识别类型
  //       const searchField = new AdvancedSearchField()
  //       searchField.action = AdvancedSearchField.UPDATE_ACTION
  //       searchField.itemType = 'select'
  //       searchField.fieldType = 'FIELD_MULTI_DROP_DOWN_LIST'
  //       searchField.itemName = 'intelligentDocument.IDENTIFICATION_TYPE'
  //       searchField.itemLabel = 'CargoMsg.Cargo_IdentificationType'
  //       searchField.defaultSelected = 1
  //       searchField.selected = 1
  //       searchField.multiple = 1
  //       searchField.dataProvider = typeList
  //       defaultSearchFields.push(searchField.formatObj2Json())
  //       this.customSearchItems = defaultSearchFields
  //     }
  //   }
  // },
  methods: {
    handleSearch(type, val) {
      let value = val || null
      if (type === 'range' && !this.showFormItem) {
        return
      }
      if (type === 'refresh' && this.showFormItem) {
        value = this.dateRange
      }
      if (type === 'select') {
        value = this.searchConditions.identificationType
      }
      this.$emit('change', { type, value })
    },
    toQuery(data) {
      // 高级查询条件组装
      this.filter.conditions = data
      console.log('this.filter.conditions:', this.filter.conditions)
      this.$emit('toQuery')
    },
    // 批量操作
    batchHandle(val) {
      switch (val) {
        case 1:
          this.$emit('batchDelete')
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
// 影响高级查询的 下拉框样式，末尾复制有问题
//::v-deep .el-input__suffix {
//  width: 40px !important;
//}

//.intelligent-booking{
//  .search-bar{
//    display: flex;
//    position: relative;
//    margin: 5px;
//    &-input{
//      display: inline-flex;
//      span{
//        width: 100px;
//      }
//      .el-button{
//        margin-left: 5px;
//      }
//    }
//    &-form-item{
//      margin: 7px;
//      padding-left: 30px;
//    }
//  }
//}
</style>
